import { jsx } from 'react/jsx-runtime';
import Collapsible from '@kunukn/react-collapse';
import { themedColor, useAccordion } from '@lemonade-hq/cdk';
import React from 'react';
import styled from 'styled-components';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  cursor: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  transition: height 0.3s ease;\n  color: 'inherit';\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Details = styled.div(_templateObject(), function(param) {
    var disabled = param.disabled;
    return disabled ? themedColor("cloud") : "inherit";
}, function(param) {
    var disabled = param.disabled;
    return disabled ? "not-allowed" : "default";
});
var Collapse = styled(Collapsible)(_templateObject1());
var AccordionDetails = function(_param, ref) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    var _useAccordion = useAccordion(), id = _useAccordion.id, isOpen = _useAccordion.isOpen, disabled = _useAccordion.disabled, getDetailsProps = _useAccordion.getDetailsProps;
    return /*#__PURE__*/ jsx(Details, _object_spread_props(_object_spread(_object_spread_props(_object_spread({
        disabled: disabled
    }, getDetailsProps({
        "data-testid": "".concat(id, "-header")
    })), {
        ref: ref
    }), props), {
        children: /*#__PURE__*/ jsx(Collapse, {
            isOpen: isOpen,
            children: children
        })
    }));
};
var AccordionDetailsWithRef = /*#__PURE__*/ React.forwardRef(AccordionDetails);
var AccordionDetailsWithMemo = /*#__PURE__*/ React.memo(AccordionDetailsWithRef);

export { AccordionDetailsWithMemo as AccordionDetails };
